import merge from 'deepmerge';

import { Translations } from '../types';

import common from './common';
import customer from './customer';
import fr from './fr/web.json';
import en from './en/web.json';
import de from './de/web.json';
import frCH from './fr-CH/web.json';
import deCH from './de-CH/web.json';
import deAT from './de-AT/web.json';

const web = {
  fr: fr.web,
  en: en.web,
  de: de.web,
  // @ts-ignore TODO: remove ts-ignore when locale is populated
  'fr-CH': merge(fr.web, frCH.web || {}),
  // @ts-ignore TODO: remove ts-ignore when locale is populated
  'de-CH': merge(de.web, deCH.web || {}),
  // @ts-ignore TODO: remove ts-ignore when locale is populated
  'de-AT': merge(de.web, deAT.web || {}),
};

export default merge.all<Translations>([common, customer, web]);
